<div class="div_employees">
    <div class="pos-title-header">
      <label class="lbl_top">{{'MANAGER_EMPLOYEE_ORDERS.ORDER_DETAILS' | translate}}</label>
    </div>
    <div class="employees_container">
      <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
      <div *ngFor="let employee of listAllWaiters" class="employee_card">
        <p-card (click)="goToOrders(employee)" styleClass="p-card-shadow clickable-p-card">
          <ng-template pTemplate="header">
            <div [style.background-image]="'url(' + determineImageForEmployee(employee.pictureUrl) +')'" [ngClass]="[ employee.isActive ? 'employee_card_img'  : 'removed_employee_card_img', ]">
              <div *ngIf="!employee.isActive" class="centered_text_removed_employee">{{'MANAGER_EMPLOYEE_ORDERS.REMOVED' | translate | uppercase }}</div>
            </div>
          </ng-template>
          <ng-template pTemplate="body">
            <div class="d-flex flex-row me-3 items_center">
              <img class="employee_picture_list"
                   [src]="employee.pictureUrl ? employee.pictureUrl : imagePath "
                   alt="profile-picture">
              <div class="employee_info" title="{{employee.firstName + ' ' + employee.lastName}}">
                <h5 class="title"><span>{{employee.firstName}}
                              </span><span>{{employee.lastName}}</span></h5>
                <div class="employee_role">
                  <span> {{'EMPLOYEES.' + EmployeeRoleEnum[employee.venueEmployeeTypeId].toUpperCase() | translate}}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-card>
      </div>
    </div>
  </div>
